import React, { Component } from 'react';
import { ToggleButtonGroup, ToggleButton } from 'react-bootstrap';
import '../content/css/Checkbox.css';

var select_icon = require("../content/images/select_icon[1].png");
var unselect_icon = require("../content/images/unselect_icon[1].png");

export default class Checkbox extends Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            value: this.props.value ? true : false
        };
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.value != this.props.value) {
            let value = this.props.value ? true : false;
            this.setState({ value })
        }
    }

    handleChange = () => {
        let value = !this.state.value;
        this.setState({ value })
        this.props.onChange(value);
    }

    getIcon() {
        return this.state.value ? select_icon : unselect_icon;
    }

    render() {
        return (
            <div className="circle">
                <ToggleButtonGroup className={'btn-group-select'} type="checkbox" name="selection" value={[this.state.value]} onChange={this.handleChange}>
                    <ToggleButton className={'btn-select'} value={false} disabled={this.props.isDisabled}><img src={this.getIcon()} /></ToggleButton>
                </ToggleButtonGroup>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Checkbox.js